import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaUpload } from "react-icons/fa";
import Swal from "sweetalert2";

const Profile = () => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) || {}
  );
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    image: null,
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setFormData({
      name: user.name || "",
      email: user.email || "",
      password: "",
      image: null,
    });
  }, [user]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      if (formData.password) data.append("password", formData.password);
      if (formData.image) data.append("image", formData.image);

      const token = localStorage.getItem("token");

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/update-profile`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire("Updated!", "Profile updated successfully", "success");
      setUser(response.data.user);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      setShowModal(false);
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.error || "Update failed",
        "error"
      );
    }
  };

  return (
    <div
      className="container mt-5"
      style={{ maxWidth: "800px", minHeight: "80vh" }}
    >
      <div className="card shadow-lg border-0">
        <div className="card-body text-center p-5">
          <div className="mb-4 position-relative">
            <img
              src={
                user.image
                  ? `${process.env.REACT_APP_API_URL}/${user.image}`
                  : "https://ui-avatars.com/api/?name=User&background=random&size=100"
              }
              alt="Profile"
              className="rounded-circle border border-3 shadow"
              style={{ width: "150px", height: "150px", objectFit: "cover" }}
            />
            <button
              className="btn btn-sm btn-outline-primary position-absolute"
              style={{ right: "10px", top: "10px" }}
              onClick={() => setShowModal(true)}
              title="Edit"
            >
              <FaEdit />
            </button>
          </div>
          <h3 className="fw-bold">{user.name}</h3>
          <div className="mt-4">
            <p className="mb-3">
              📧 <strong>Email:</strong> {user.email}
            </p>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal d-block fade show"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "#00000080" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Update Profile</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="modal-body">
                  {/* Name */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  {/* Password */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      New Password (optional)
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  {/* Image Upload */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Upload Image</label>
                    <div className="d-flex align-items-center gap-3">
                      <input
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={handleChange}
                        className="form-control"
                      />
                      <FaUpload />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary fw-bold">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
